<div class="center">
    <img  class="oversize" cImg src="assets/images_logo/FLC-partners-v1.png"/>
</div>
